import React from 'react'
import './Header.css'

function Header() {
  return (
    <div>
      <header className="app-header"> 
        <img src={`${import.meta.env.BASE_URL}evernorth-logo.svg`} alt="Evernorth Logo" className="app-logo"/>
        <h1 className="app-title">Embarc Client Portal</h1>
      </header>
    </div>
  )
}

export default Header
